import styled from 'styled-components';

const CommentItemFooter = styled.div`
  display: flex;
  flex-direction: row;
`;

export default CommentItemFooter;
